import { Status } from 'components/features/broker-table/types';
import React, { useCallback } from 'react';
import { cn } from 'utils';

interface StatusProps {
  status: Status;
}

const StatusIndicator: React.FC<StatusProps> = ({ status }) => {
  const getStatusColor = useCallback((status: Status) => {
    switch (status) {
      case 'Active':
        return {
          bg: 'bg-green-100',
          bgDark: 'bg-green-600',
          text: 'text-green-600',
        };
      case 'Inactive':
        return {
          bg: 'bg-red-100',
          bgDark: 'bg-red-600',
          text: 'text-red-600',
        };
      case 'Upcoming':
        return {
          bg: 'bg-yellow-100',
          bgDark: 'bg-yellow-600',
          text: 'text-yellow-600',
        };
      case 'Expired':
        return {
          bg: 'bg-red-100',
          bgDark: 'bg-red-600',
          text: 'text-red-600',
        };
    }
  }, []);

  return (
    <div className="flex items-center h-full">
      <span
        className={cn(
          'inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium',
          getStatusColor(status).bg,
          getStatusColor(status).text
        )}
      >
        <span
          className={cn('w-2 h-2 rounded-full', getStatusColor(status).bgDark)}
        />
        {status}
      </span>
    </div>
  );
};

export default StatusIndicator;
